import type { ValueGetterParams } from 'ag-grid-community';
import { get } from 'lodash-es';
import { text, type TextColumnParams } from './text';
import type { ColDefFactory, Column } from './types';

export interface SecurityTextColumnParams extends TextColumnParams {
  /**
   * Symbol for the Security to lookup in the securitiesBySymbol map
   */
  symbolField: string;
  /**
   * Property for the value on the Security
   */
  securityField: string;
}

/**
 * Text column to render values from the Security object
 * - to avoid field confusion, the column property 'Field' is not involved here, but the params must be set to the correct symbolField and securityField
 * - use the column ID to ensure uniqueness on your field when it comes to the column definitions
 *
 * See {@link AgGridSecurityProps} for parameter options.
 */
export const securityText: ColDefFactory<Column<SecurityTextColumnParams>> = column => ({
  ...text(column),
  valueGetter: (params: ValueGetterParams<unknown>) => {
    if (!column.field || !params.node?.data || !column.params) {
      return undefined;
    }
    const symbol = get(params.node.data, column.params.symbolField);
    const security = symbol ? params.context.current.securitiesBySymbol?.get(symbol) : undefined;
    return get(security, column.params.securityField);
  },
});
